import React, { useContext, useEffect, useState, useMemo } from 'react';

import FilteringTable from './Table/FilteringTable/FilteringTable';
import ColumnFilter from './Table/FilteringTable/ColumnFilter';
import PageTitle from '../layouts/PageTitle';

import { tableColumnNamesNominationAdministration } from '../../utils/tableColumnNamesNominationAdministration';
import { tableRowsValuesNominationAdministration } from '../../utils/tableRowsValuesNominationAdministration';
import { arrayToFlatObject } from '../../utils/arrayToFlatObject';
import AdminNominationCell from './AdminNominationCell';

import { CommonCollections } from '../../App';

import { filteringTableGetTableColumns } from '../../utils/filteringTableGetTableColumns';
import { filteringTableFilterUniqueCandidates } from '../../utils/filteringTableFilterUniqueCandidates';
import { useStaticCollections } from '../../context/StaticCollections';
import { useAdminCollections } from '../../context/AdminCollections';

const AdminNomination = () => {
  const {
    electionTypes,
    fellows,
    nominationStatusTypes,
    sectionalCommitteesWithCmse,
    usersArray,
    isLoading: staticLoading,
  } = useStaticCollections();

  const {
    candidates,
    nominationArray,
    nominationStateArray,
    proposerSeconder,
    draftNominationArray,
    isLoading: adminLoading,
  } = useAdminCollections();

  const updatedArray = useMemo(
    () =>
      (draftNominationArray || []).map((item) => ({
        ...item,
        id: `${item.id}d`,
      })),
    [draftNominationArray],
  );

  const mergedData = useMemo(
    () => [...(nominationArray || []), ...(updatedArray || [])],
    [nominationArray, updatedArray],
  );

  const { setNominationId } = useContext(CommonCollections);

  const [nominationsData, setNominationsData] = useState([]);
  const [nominationsColumns, setNominationsColumns] = useState([]);

  useEffect(() => {
    const tableColumns = filteringTableGetTableColumns(
      tableColumnNamesNominationAdministration,
      ColumnFilter,
      AdminNominationCell,
    );

    const proposers = proposerSeconder
      ? proposerSeconder.map((item) => ({
          [item.attributes.nominationId]: item.attributes.proposerFellowId,
        }))
      : [];

    const proposerSeconderObj = arrayToFlatObject(proposers);

    const tableData = tableRowsValuesNominationAdministration(
      mergedData,
      proposerSeconderObj,
      electionTypes,
      nominationStatusTypes,
      sectionalCommitteesWithCmse,
      fellows,
      nominationStateArray,
      usersArray,
    );

    setNominationsColumns(tableColumns);

    const tableDataTwo = Object.values(tableData).map((nomination) => {
      if (candidates[nomination.candidateId] !== undefined) {
        nomination.candidate = candidates[nomination.candidateId];
      }

      return nomination;
    });

    const filteredData = filteringTableFilterUniqueCandidates(tableDataTwo);

    setNominationsData(filteredData);
    setNominationId(null);
  }, [
    electionTypes,
    nominationStatusTypes,
    sectionalCommitteesWithCmse,
    fellows,
    candidates,
    proposerSeconder,
    nominationArray,
    nominationStateArray,
    setNominationId,
    usersArray,
    mergedData,
  ]);
  if (staticLoading || adminLoading) {
    return (
      <>
        <PageTitle activeMenu='Nomination' motherMenu='Home' />
        <div className='card'>
          <div className='card-body text-center py-5'>
            <div className='spinner-border text-primary' role='status'>
              <span className='visually-hidden'>Loading nominations...</span>
            </div>
            <p className='mt-3 text-muted mb-0'>Loading nominations...</p>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <PageTitle activeMenu='Nomination' motherMenu='Home' />
      <FilteringTable
        componentName='AdminNomination'
        columns={nominationsColumns}
        data={nominationsData}
        urlString='application-administration'
        buttonText='New Nomination'
        isLoading={staticLoading || adminLoading}
      />
    </>
  );
};

export default AdminNomination;
